import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { LinkedInEmbed } from "react-social-media-embed";

import "./CollapsibleSidenav.scss";
import { linkLabels } from "../../service/utils/constants";
import { PagePermissionMask } from "../../service/utils/interfaces";
import { checkPagePermissions } from "../../service/utils/functions";

interface CollapsibleSidenavProps {
  collapsed: boolean;
  expanding: boolean;
  darkMode: boolean;
  onCollapseTrigger: () => void;
  featuredPostShareID: string;
  screenWidth: number;
  screenHeight: number;
  permMask?: PagePermissionMask;
  isTippingUser: boolean;
}

const CollapsibleSidenav = (props: CollapsibleSidenavProps) => {
  return (
    <div
      className={
        "sidenav-container" +
        (props.collapsed
          ? " collapsed" + (props.expanding ? " expanding" : "")
          : "") +
        (props.darkMode ? " dark" : "")
      }
    >
      <div
        className="navigation-links"
        style={{ visibility: props.permMask ? "visible" : "hidden" }}
      >
        {linkLabels.map((link, idx) => {
          const isVisible = checkPagePermissions(
            link.name,
            props.isTippingUser,
            props.permMask
          );
          return (
            <div
              key={"dashboard-link-" + idx}
              style={{ display: isVisible ? "block" : "none" }}
            >
              {!link.isInternal ? (
                <a
                  className="link-item"
                  href={link.path}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon
                    className={"sidenav-icon" + (props.darkMode ? " dark" : "")}
                    icon={link.icon}
                  />
                  <span
                    className={"link-name" + (props.darkMode ? " dark" : "")}
                  >
                    {link.name === "Job List & Issues" && props.isTippingUser
                      ? "Job List"
                      : link.name}
                  </span>
                </a>
              ) : (
                <NavLink
                  className={({ isActive }) =>
                    "link-item" + (isActive ? " active" : "")
                  }
                  to={link.path}
                >
                  <FontAwesomeIcon
                    className={"sidenav-icon" + (props.darkMode ? " dark" : "")}
                    icon={link.icon}
                  />
                  <span
                    className={"link-name" + (props.darkMode ? " dark" : "")}
                  >
                    {link.name === "Job List & Issues" && props.isTippingUser
                      ? "Job List"
                      : link.name}
                  </span>
                </NavLink>
              )}
            </div>
          );
        })}
      </div>
      <div className="end-section">
        {props.featuredPostShareID.length > 0 && (
          <div
            className={
              "sm-feed-box" +
              (props.collapsed
                ? " collapsed" + (props.expanding ? " expanding" : "")
                : "")
            }
          >
            <p>Feed SM or Media</p>
            <LinkedInEmbed
              url={
                "https://www.linkedin.com/embed/feed/update/" +
                props.featuredPostShareID
              }
              width="100%"
              height={props.screenHeight * 0.306}
            />
          </div>
        )}
        <div className="collapse-btn-row">
          <FontAwesomeIcon
            className="collapse-btn"
            icon={props.collapsed ? faChevronRight : faChevronLeft}
            onClick={() => props.onCollapseTrigger()}
          />
        </div>
      </div>
    </div>
  );
};

export default CollapsibleSidenav;
